import { useCallback } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useNotificationDetailsPanel } from "../../app/notificationDetailsPanel.js";
import { NotificationDetails } from "./NotificationDetails.js";

/**
 * Mounts a bell row's Details ONCE, at the router root (ART-327/328) — see `notificationDetailsPanel.ts` for why it
 * cannot live inside the bell's dropdown. A row whose band cannot be opened from here falls back to its link.
 */
export function NotificationDetailsHost() {
  const target = useNotificationDetailsPanel((s) => s.target);
  const hide = useNotificationDetailsPanel((s) => s.hide);
  const navigate = useNavigate();
  const fallback = useCallback(() => {
    // Same-origin paths only — never a scheme or a protocol-relative URL.
    const raw = target?.row.route ?? "";
    const route = raw.startsWith("/") && !raw.startsWith("//") ? raw : null;
    hide();
    if (route) void navigate({ to: route });
  }, [target, hide, navigate]);

  if (!target) return null;
  return target.kind === "request" ? (
    <NotificationDetails row={target.row} offerId={target.offerId} onClose={hide} onFallback={fallback} />
  ) : (
    <NotificationDetails
      row={target.row}
      open={{ kind: "opportunity", id: target.id, anchor: null }}
      onClose={hide}
      onFallback={fallback}
    />
  );
}
